import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-30beed58"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "settings_button"
};
const _hoisted_2 = {
    key: 1,
    class: "setting_menu"
};
import { useMessage } from '@/const/messages';
import { ref } from 'vue';
import List from '@/materials/atoms/List.vue';
import { useStore } from '@/store/store';
import { useSettings } from '@/logics/settings';
import MaterialIcon from '@/materials/atoms/MaterialIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        isAuth: { type: Boolean, default: false }
    },
    emits: ["click"],
    setup(__props, { emit }) {
        const props = __props;
        const store = useStore();
        const { format, USER_SETTINGS_MESSAGES } = useMessage();
        const list = [
            { title: 'English', value: 'English' },
            { title: '日本語', value: 'Japanese' },
            { title: '繁體中文', value: 'Traditional' },
            { title: '简体中文', value: 'Simplified' },
        ];
        const isShowMenu = ref(false);
        const { putUserSettings } = useSettings();
        const onLanguageChange = (value) => {
            store.state.userSettings.language = value;
            if (props.isAuth) {
                putUserSettings({
                    language: value,
                });
            }
            else {
                localStorage.setItem('cryptos.language', String(value));
            }
            if (store.state.isSmartPhone) {
                emit('click');
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "outer",
                onMouseover: _cache[0] || (_cache[0] = ($event) => (isShowMenu.value = true)),
                onMouseleave: _cache[1] || (_cache[1] = ($event) => (isShowMenu.value = false))
            }, [
                (!_unref(store).state.isSmartPhone)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(MaterialIcon, {
                            class: "icon",
                            name: "language"
                        }),
                        _createTextVNode(" " + _toDisplayString(_unref(format)(_unref(USER_SETTINGS_MESSAGES).LANGUAGE_SHORT)), 1)
                    ]))
                    : _createCommentVNode("", true),
                (isShowMenu.value || _unref(store).state.isSmartPhone)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(List, {
                            language: String(_unref(store).state.userSettings.language),
                            selectionList: list,
                            width: 180,
                            onClick: onLanguageChange
                        }, null, 8, ["language"])
                    ]))
                    : _createCommentVNode("", true)
            ], 32));
        };
    }
});
